import { connect } from 'react-redux';
import { openHelp, closeHelp, nextPage, prevPage } from '../actions/research';
import Tutorial from '../components/Tutorial/Tutorial';

const mapStateToProps = (state) => {
  return {
    isOpen: state.research.isHelpOpen,
    selected: state.research.selectedHelp,
    baseUrl: '/c/application/' + state.app.code,
    toc: state.research.exercises.filter(
      (item) => item.category === 'tutorial'
    ),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openHelp: (code) => dispatch(openHelp(code)),
    closeHelp: () => dispatch(closeHelp()),
    prevExercise: () => dispatch(prevPage()),
    nextExercise: () => dispatch(nextPage()),
  };
};

const Help = connect(mapStateToProps, mapDispatchToProps)(Tutorial);

export default Help;
